import type { Workspace } from '@gripp/shared-logic';
import { ScrollView, Text } from 'react-native';
import { ImpersonateWorkspaceChip } from './impersonateWorkspaceChip';
import { themedStyleSheet } from '../../themes/themedStyleSheet';

type WorkspaceColumnProps = {
  workspaces?: Workspace[]; // array of workspaces
  canImpersonate?: boolean;
};

export const WorkspaceColumn = ({
  workspaces,
  canImpersonate,
}: WorkspaceColumnProps) => {
  if (!workspaces || workspaces.length === 0) {
    return <Text style={styles.empty}>-</Text>;
  }

  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      style={styles.container}
    >
      {workspaces.map((ws, index) =>
        canImpersonate ? (
          <ImpersonateWorkspaceChip
            key={ws.id || index}
            workspace={ws}
            additionalStyle={styles.chip}
          />
        ) : (
          <Text key={ws.id || index} style={styles.nameOnly}>
            {ws.name}
          </Text>
        )
      )}
    </ScrollView>
  );
};

const styles = themedStyleSheet((role) => ({
  container: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  chip: {
    marginRight: 4,
  },
  nameOnly: {
    margin: 4,
    fontSize: 14,
    color: role.textStrong,
  },
  empty: {
    fontSize: 14,
    color: role.surfaceHover,
  },
}));
